import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/production-product-requests`;

export const productionProductRequestsAPI = {
  async getAll() {
    return apiClient(`${BASE}/`);
  },

  async getAllItems() {
    return apiClient(`${BASE}/items`);
  },

  async getById(id) {
    return apiClient(`${BASE}/${id}`);
  },

  async create(data) {
    return apiClient(`${BASE}/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return apiClient(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  /** Actualiza estado, OP, fecha y hora límite o notas (Planificación), sin reemplazar ítems. */
  async updatePlanning(
    id,
    { status, op_code, needed_by_date, needed_by_time, notes, rejection_reason, reschedule_reason }
  ) {
    return apiClient(`${BASE}/${id}/planning`, {
      method: 'PATCH',
      body: JSON.stringify({
        status,
        op_code,
        needed_by_date,
        needed_by_time,
        notes,
        rejection_reason,
        reschedule_reason,
      }),
    });
  },

  async updateItemProgress(itemId, progress_status) {
    return apiClient(`${BASE}/items/${itemId}/progress`, {
      method: 'PATCH',
      body: JSON.stringify({ progress_status }),
    });
  },

  async listByDelivery(deliveryId) {
    return apiClient(`${BASE}/by-delivery/${deliveryId}`);
  },

  async bulkDelete(ids) {
    return apiClient(`${BASE}/bulk-delete`, {
      method: 'POST',
      body: JSON.stringify({ ids }),
    });
  },
};

export default productionProductRequestsAPI;
